import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Text from './Text';
import MagneticButton from './animated/MagneticButton';
import { gradients, colors } from '../theme/designTokens';

const CtaSection = ({
  title = 'Ready to engineer resilience?',
  subtitle = 'Partner with ALEgION to design a protection architecture built for uncertainty.',
  primaryLabel = 'Start a Conversation',
  primaryPath = '/contact',
  secondaryLabel = 'Explore AERA™',
  secondaryPath = '/framework',
  showSecondary = true,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        background: gradients.cta,
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 8, md: 10 },
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        borderTop: `1px solid ${colors.border}`,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: gradients.mesh,
          pointerEvents: 'none',
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 1, maxWidth: 720, mx: 'auto' }}>
        <Text variant="ctaTitle" sx={{ mb: 2, color: colors.ochreLight }}>
          {title}
        </Text>
        <Text variant="ctaBody" color="muted" sx={{ maxWidth: 520, mx: 'auto', mb: 4 }}>
          {subtitle}
        </Text>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <MagneticButton onClick={() => navigate(primaryPath)}>{primaryLabel}</MagneticButton>
          {showSecondary && (
            <MagneticButton variant="outline" onClick={() => navigate(secondaryPath)}>
              {secondaryLabel}
            </MagneticButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CtaSection;
